import React from "react";
import { Button } from "aible";

import MarketplaceTile from "components/Market/MarketplaceTile";

import styles from "./style.module.css";

const MarketOverview = (props) => {
  const { setType } = props;

  const renderOverviewSummaryPanel = (type) => {
    const { consultants, jobs } = props;

    const jobData = [
      {
        title: "2 Month Contract for Data Prep and AI Creation",
        subTitle: "Data Exploration / AI Creation"
      },
      {
        title: "6 Month Contract for AI creation and deployment",
        subTitle: "AI Creation / Deployment"
      },
      {
        title: "Part-time Data Exploration and Analysis",
        subTitle: "Data Exploration"
      },
      {
        title: "2 Month Contract for Data Prep and AI Creation",
        subTitle: "Data Exploration / AI Creation"
      }
    ];

    const headers = [
      {
        type: "hire consultants",
        title: consultants.length + " Consultants Available for Hire",
        subTitle: "3   new consultants available this week!",
        color: "#7E69D7"
      },
      {
        type: "job postings",
        title: jobs.length + " Jobs Available",
        subTitle: "2 new listings this week!",
        color: "#C8CAD4"
      },
      {
        type: "find blueprints",
        title: "498 Blueprints Available",
        subTitle: "15 new blueprints this week!",
        color: "#4A90E2"
      },
      {
        type: "find data",
        title: "7050 Datasets Available",
        subTitle: "34 new datasets available this week!",
        color: "#34D399"
      }
    ];
    const currentHeader = headers.find((header) => header.type === type);

    const listData = type === "hire consultants" ? consultants : type === "job postings" ? jobs : jobData;

    return (
      <div className={styles.overviewSummaryPanel}>
        <div className={styles.overviewSummaryHeader}>
          <div className={styles.overviewSummaryHeaderTextSection}>
            <div className={styles.overviewSummaryPanelHeaderTitle}>{currentHeader.title}</div>
            <div>{currentHeader.subTitle}</div>
          </div>
          <div className={styles.overviewSummaryPanelHeaderButton}>
            <Button type="secondary" style={{ maxHeight: "35px" }} onClick={() => setType(type)}>
              View More
            </Button>
          </div>
        </div>
        <div className={styles.overviewSummaryBody}>
          {listData.map((data, index) => (
            <MarketplaceTile
              title={data.contractLength ? data.title : data.subTitle}
              subTitle={data.contractLength ? data.contractLength + " " + data.contractType : data.title}
              key={index}
              headerColor={currentHeader.color}
            />
          ))}
        </div>
      </div>
    );
  };

  const { updateIsCreateConsultant, updateIsCreateJob } = props;

  return (
    <React.Fragment>
      <div className={styles.overviewBannerContainer}>
        <div className={styles.overviewBanner}>
          <div className={styles.overviewTitle}>Welcome to the Aible Marketplace!</div>
          <div style={{ marginBottom: "20px" }}>
            Your one spot to find collaborators or resources to help on your current projects
          </div>
          <div style={{ marginBottom: "20px" }}>
            Looking to sell blueprints or skillsets? Start by posting it to the marketplace.
          </div>
          <div>
            <Button type="secondary" style={{ marginRight: "10px" }} onClick={() => updateIsCreateJob(true)}>
              Post a Job
            </Button>
            <Button type="secondary" onClick={() => updateIsCreateConsultant(true)}>
              Sell My Work
            </Button>
          </div>
        </div>
        {renderOverviewSummaryPanel("job postings")}

        {/* <div style={{ marginLeft: "-40px" }}>
            <img src={marketLogo} alt="marketplace logo" />
          </div> */}
      </div>
      <div className={styles.overviewRightColumn}>
        {renderOverviewSummaryPanel("hire consultants")}
        {renderOverviewSummaryPanel("find blueprints")}
        {renderOverviewSummaryPanel("find data")}
      </div>
    </React.Fragment>
  );
};

export default MarketOverview;
